import { RootState } from "../../applicationStore";
import { createSelector } from "@reduxjs/toolkit";
import { SiteState } from "../types/SiteState";

export const getSiteState = (state: RootState): SiteState => state.site;

export const isOnline = createSelector(
  getSiteState,
  (siteState): boolean | null =>
    process.env.NODE_ENV === "development"
      ? siteState.data.isLocalOnline
      : siteState.data.isOnline,
);

export const hasError = createSelector(
  getSiteState,
  (siteState): boolean | null => siteState.hasError,
);

export const hasBeenChecked = createSelector(
  getSiteState,
  (siteState): boolean => siteState.checked,
);

export const getData = createSelector(
  getSiteState,
  (siteState): string => siteState.data.date,
);

export const getCompleteData = createSelector(
  getSiteState,
  (siteState): string => siteState.data.date + " " + siteState.data.anno,
);

export const usedHooks = createSelector(
  getSiteState,
  (siteState): string[] => siteState.usedHooks,
);
